"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeacherSelection = void 0;
var _react = require("react");
var _main = require("../../../../main");
var _hooks = require("../../../../hooks");
var _EnvironmentManager = require("../../EnvironmentManager.provider");
var _EnvironmentManager2 = _interopRequireDefault(require("../../EnvironmentManager.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TeacherSelection = props => {
  const styles = (0, _EnvironmentManager2.default)();
  const {
    selectedTeachers,
    isDisabled,
    onChange
  } = props;
  const {
    schoolTeachers,
    getLabel
  } = (0, _react.useContext)(_EnvironmentManager.EnvironmentManagerContext);
  const {
    isMobileView,
    isMobile
  } = (0, _hooks.useDeviceData)();
  const showMultipeTeacherNames = !isMobileView && !isMobile;
  const schoolTeachersOptions = (0, _react.useMemo)(() => schoolTeachers?.map(teacher => {
    return {
      value: teacher.user.id,
      label: teacher.user.fullName
    };
  }) || [], [schoolTeachers]);
  const selectedTeacherNames = (0, _react.useMemo)(() => selectedTeachers?.length ? showMultipeTeacherNames ? selectedTeachers.map(st => st.label).join(', ') : undefined : getLabel('select'), [showMultipeTeacherNames, selectedTeachers, getLabel]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-EnvironmentManager_Row'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-EnvironmentManager_Cell_Label'],
      children: getLabel('teacher_operator')
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-EnvironmentManager_Cell_Content'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Select, {
        id: "environmentTeachers",
        isMultiSelect: true
        //showSelection={true}
        //btnLabel={selectedTeachers?.length ? undefined : getLabel('select')}
        ,
        isWithFilter: true,
        values: selectedTeachers,
        showSelection: !showMultipeTeacherNames,
        btnLabel: selectedTeacherNames,
        filterPlaceholder: getLabel('search'),
        onChange: options => onChange(options),
        onSecondaryBtnClick: () => {
          onChange([]);
        },
        btnProps: {
          isDisabled: isDisabled,
          color: 'basic',
          customStyle: {
            width: '100%'
          },
          view: 'outlined'
        },
        options: schoolTeachersOptions
      })
    })]
  });
};
exports.TeacherSelection = TeacherSelection;